// Layout
import React from 'react';
import { MainProductsUser } from '../../layouts/MainProductsUser/MainProductsUser'

export const ProductsUser = () => {
  return (
    <MainProductsUser />
  )
}
